var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "label-new" },
    [
      _c("icon-check-mark"),
      _vm._v(" "),
      _c("label", { staticClass: "ml-4 label-new__name" }, [_vm._v("Новая")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }